import { useLocation } from "react-router-dom";
import { Phone, MessageSquare } from "lucide-react";
import { BUSINESS } from "../lib/site";

const MobileCallBar = () => {
    const { pathname } = useLocation();
    if (pathname.startsWith("/admin")) return null;

    return (
        <div
            data-testid="mobile-call-bar"
            className="md:hidden fixed bottom-0 inset-x-0 z-40 border-t border-brand-line bg-brand-ink/90 backdrop-blur-xl px-3 pt-2 pb-[max(0.5rem,env(safe-area-inset-bottom))]"
        >
            <div className="grid grid-cols-2 gap-2">
                <a
                    href={BUSINESS.phoneTel}
                    data-testid="mobile-bar-call-btn"
                    className="inline-flex items-center justify-center gap-2 bg-brand-amber text-brand-ink font-bold text-sm py-3 rounded-full active:scale-[0.98] transition-transform"
                >
                    <Phone className="w-4 h-4" />
                    Call now
                </a>
                <a
                    href={BUSINESS.phoneSms}
                    data-testid="mobile-bar-text-btn"
                    className="inline-flex items-center justify-center gap-2 border border-brand-amber/60 text-brand-amber font-bold text-sm py-3 rounded-full active:scale-[0.98] transition-transform"
                >
                    <MessageSquare className="w-4 h-4" />
                    Text a photo
                </a>
            </div>
        </div>
    );
};

export default MobileCallBar;
